"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnicodeDecodeB64 = exports.b64EncodeUnicode = exports.removeQueryParamsFromUrl = void 0;
var removeQueryParamsFromUrl = function (url, params) {
    try {
        var _a = url.split("?"), base = _a[0], queryString = _a[1];
        if (!queryString) {
            base;
        }
        var urlSearchParams = new URLSearchParams(queryString);
        var dirtyParams = urlSearchParams.entries();
        var cleaned = Array.from(dirtyParams).filter(function (_a) {
            var param = _a[0];
            return !params.includes(param);
        });
        var reduced = cleaned.reduce(function (acc, _a) {
            var _b;
            var param = _a[0], value = _a[1];
            return __assign(__assign({}, acc), (_b = {}, _b[param] = value, _b));
        }, {});
        if (!cleaned.length) {
            return base;
        }
        var queryParams = new URLSearchParams(reduced);
        return "".concat(base, "?").concat(queryParams);
    }
    catch (err) {
        return url;
    }
};
exports.removeQueryParamsFromUrl = removeQueryParamsFromUrl;
var b64EncodeUnicode = function (str) {
    return btoa(encodeURIComponent(str));
};
exports.b64EncodeUnicode = b64EncodeUnicode;
var UnicodeDecodeB64 = function (str) {
    return decodeURIComponent(atob(str));
};
exports.UnicodeDecodeB64 = UnicodeDecodeB64;
